export default __webpack_public_path__ + "6f07f394efccb755a2b2ec83b058f9ca.svg";